import React, { useState } from 'react';
import FormInput from '../common/FormInput';
import TextInput from '../common/textInput/TextInput';
import Button from '../common/button/Button';
import PageTitle from '../common/PageTitle';
import { CommonValidation } from '../common/commonValidation/commonValidation';
import { useTranslation } from 'react-i18next';

type UserDetailErrors = {
    postcode?: string;
    surname?: string;
};

type UserDetailFormProps = {
    initialPostcode: string;
    initialSurname: string;
    loading: boolean;
    onUserDetailsSubmitted: (postcode: string, surname: string) => void;
};

const UserDetailForm = ({
    initialPostcode,
    initialSurname,
    loading,
    onUserDetailsSubmitted
}: UserDetailFormProps): JSX.Element => {
    const [postcode, setPostcode] = useState(initialPostcode);
    const [surname, setSurname] = useState(initialSurname);
    const [detailErrors, setDetailErrors] = useState<UserDetailErrors>(null);

    const { t } = useTranslation();

    const updateUserDetails = (
        event: React.FormEvent<HTMLInputElement>,
        key: string
    ) => {
        const value = event.currentTarget.value;

        switch (key) {
            case 'postcode':
                setPostcode(value);
                break;
            case 'surname':
                setSurname(value);
                break;
            default:
                break;
        }
    };

    const onSearchClick = () => {
        if (validateForm()) {
            onUserDetailsSubmitted(postcode, surname);
        }
    };

    const validateForm = () => {
        let errors: UserDetailErrors = {};
        let isValid = true;

        if (CommonValidation.isEmpty(postcode)) {
            isValid = false;
            errors = {
                ...errors,
                postcode: t('post_code_is_required_error')
            };
        } else if (!CommonValidation.isValidAlphaNumeric(postcode)) {
            isValid = false;
            errors = {
                ...errors,
                postcode: t('postcode_validation_error')
            };
        }

        if (CommonValidation.isEmpty(surname)) {
            isValid = false;
            errors = {
                ...errors,
                surname: t('surname_is_required')
            };
        }

        setDetailErrors(errors);

        return isValid;
    };

    return (
        <div className='card page-content'>
            <PageTitle title={t('find_vehicles')} />
            <div className='card-body page-content-body'>
                <FormInput
                    id='user-detail-form'
                    label={t('enter_your_details')}>
                    <div className='row repair-request-field-container'>
                        <div className='col-xs-12 col-lg-6'>
                            <TextInput
                                label={t('postcode')}
                                name='postcode'
                                value={postcode}
                                error={detailErrors?.postcode}
                                readOnly={loading}
                                onChange={(e) =>
                                    updateUserDetails(e, 'postcode')
                                }
                            />
                        </div>
                    </div>
                    <div className='row repair-request-field-container'>
                        <div className='col-xs-12 col-lg-6'>
                            <TextInput
                                label={t('surname')}
                                name='surname'
                                value={surname}
                                error={detailErrors?.surname}
                                readOnly={loading}
                                onChange={(e) =>
                                    updateUserDetails(e, 'surname')
                                }
                            />
                        </div>
                    </div>
                    <Button
                        name='btn-search'
                        className='btn btn-primary'
                        text={t('search')}
                        waitValue={loading}
                        waitText={t('searching')}
                        disabled={loading}
                        onClick={onSearchClick}
                    />
                </FormInput>
            </div>
        </div>
    );
};

export default UserDetailForm;
